import * as React from "react";
const SvgGridIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.6673 4.66732C11.6673 4.20061 11.6673 3.96725 11.7581 3.78899C11.838 3.63219 11.9655 3.50471 12.1223 3.42481C12.3006 3.33398 12.5339 3.33398 13.0007 3.33398H15.334C15.8007 3.33398 16.0341 3.33398 16.2123 3.42481C16.3691 3.50471 16.4966 3.63219 16.5765 3.78899C16.6673 3.96725 16.6673 4.20061 16.6673 4.66732V7.00065C16.6673 7.46736 16.6673 7.70072 16.5765 7.87898C16.4966 8.03578 16.3691 8.16326 16.2123 8.24316C16.0341 8.33398 15.8007 8.33398 15.334 8.33398H13.0007C12.5339 8.33398 12.3006 8.33398 12.1223 8.24316C11.9655 8.16326 11.838 8.03578 11.7581 7.87898C11.6673 7.70072 11.6673 7.46736 11.6673 7.00065V4.66732Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.33398 4.66732C3.33398 4.20061 3.33398 3.96725 3.42481 3.78899C3.50471 3.63219 3.63219 3.50471 3.78899 3.42481C3.96725 3.33398 4.20061 3.33398 4.66732 3.33398H7.00065C7.46736 3.33398 7.70072 3.33398 7.87898 3.42481C8.03578 3.50471 8.16326 3.63219 8.24316 3.78899C8.33398 3.96725 8.33398 4.20061 8.33398 4.66732V7.00065C8.33398 7.46736 8.33398 7.70072 8.24316 7.87898C8.16326 8.03578 8.03578 8.16326 7.87898 8.24316C7.70072 8.33398 7.46736 8.33398 7.00065 8.33398H4.66732C4.20061 8.33398 3.96725 8.33398 3.78899 8.24316C3.63219 8.16326 3.50471 8.03578 3.42481 7.87898C3.33398 7.70072 3.33398 7.46736 3.33398 7.00065V4.66732Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.33398 13.0007C3.33398 12.5339 3.33398 12.3006 3.42481 12.1223C3.50471 11.9655 3.63219 11.838 3.78899 11.7581C3.96725 11.6673 4.20061 11.6673 4.66732 11.6673H7.00065C7.46736 11.6673 7.70072 11.6673 7.87898 11.7581C8.03578 11.838 8.16326 11.9655 8.24316 12.1223C8.33398 12.3006 8.33398 12.5339 8.33398 13.0007V15.334C8.33398 15.8007 8.33398 16.0341 8.24316 16.2123C8.16326 16.3691 8.03578 16.4966 7.87898 16.5765C7.70072 16.6673 7.46736 16.6673 7.00065 16.6673H4.66732C4.20061 16.6673 3.96725 16.6673 3.78899 16.5765C3.63219 16.4966 3.50471 16.3691 3.42481 16.2123C3.33398 16.0341 3.33398 15.8007 3.33398 15.334V13.0007Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.6673 13.0007C11.6673 12.5339 11.6673 12.3006 11.7581 12.1223C11.838 11.9655 11.9655 11.838 12.1223 11.7581C12.3006 11.6673 12.5339 11.6673 13.0007 11.6673H15.334C15.8007 11.6673 16.0341 11.6673 16.2123 11.7581C16.3691 11.838 16.4966 11.9655 16.5765 12.1223C16.6673 12.3006 16.6673 12.5339 16.6673 13.0007V15.334C16.6673 15.8007 16.6673 16.0341 16.5765 16.2123C16.4966 16.3691 16.3691 16.4966 16.2123 16.5765C16.0341 16.6673 15.8007 16.6673 15.334 16.6673H13.0007C12.5339 16.6673 12.3006 16.6673 12.1223 16.5765C11.9655 16.4966 11.838 16.3691 11.7581 16.2123C11.6673 16.0341 11.6673 15.8007 11.6673 15.334V13.0007Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgGridIcon;
